<div
  *ngIf="parentModalRendered"
  #listContainer
  class="social-list"
  [style.height]="scrollerHeight"
  (scroll)="onScroll($event)"
>
  <ng-container *ngIf="initialLoading; else socialListContent">
    <div class="social-list__item" *ngFor="let _ of skeletonRows">
      <div class="grid grid-nogutter flex justify-content-start align-items-center width-100 pl-3" style="gap: 10px">
        <div class="col-fixed">
          <p-skeleton shape="circle" size="4rem"></p-skeleton>
        </div>
        <div class="col-6" style="min-width: 200px">
          <div class="mb-2">
            <p-skeleton width="70%" height="1.5rem" borderRadius="16px"></p-skeleton>
          </div>
          <div class="mb-2">
            <p-skeleton width="90%" height="1rem" borderRadius="16px"></p-skeleton>
          </div>
          <div class="flex" style="gap: 6px">
            <ng-container *ngFor="let __ of skeletonThumbs">
              <p-skeleton shape="circle" size="2.25rem"></p-skeleton>
            </ng-container>
          </div>
        </div>
        <div class="col-fixed flex ml-auto gap-2 relative w-3rem h-3rem">
          <p-skeleton shape="circle" size="3rem"></p-skeleton>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #socialListContent>
    <div *ngIf="unloadedItemsCount" class="social-list__trimmed-note">
      {{ trimmedTranslationKey | translate: {count: unloadedItemsCount} }}
    </div>

    <ng-container *ngIf="renderedItems.length; else emptyState">
      <div class="social-list__item" *ngFor="let item of renderedItems; trackBy: trackByItem">
        <app-social-list-item-host
          [componentType]="itemComponent"
          [item]="item"
          [currentUser]="currentUser"
          [socialDPS]="socialDPS"
          [navigateTo]="navigateTo"
          [swiperConfig]="swiperConfig"
          [rendererInputs]="adapter?.rendererInputs"
        ></app-social-list-item-host>
      </div>
    </ng-container>

    <div *ngIf="loadingMore" class="social-list__loader">
      <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="4" fill="var(--surface-ground)" animationDuration=".5s">
      </p-progressSpinner>
    </div>
  </ng-template>
</div>

<ng-template #emptyState>
  <p class="social-list__empty muted-text">
    {{ emptyTranslationKey | translate }}
  </p>
</ng-template>
